module.exports = __webpack_public_path__ + "img/icon.c06c0677.png";